import React from "react";
import { FaBed, FaUtensils, FaUsers, FaBusAlt, FaTrain, FaClinicMedical } from "react-icons/fa";

function OurServices() {
  return (
   

    <div className="text-center py-10 px-10" style={{ backgroundImage: "url('/bgphoto.jpg')" }}>
      <h1 className="text-3xl md:text-4xl text-orange-800 mb-10 font-yatra">
        आमच्या सेवा
      </h1>
    
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Service 1 */}
      <div className="p-6 border rounded-lg shadow-lg hover:shadow-2xl transition bg-white">
  <FaBed className="text-5xl text-orange-500 mb-4 mx-auto" />
  <h2 className="text-2xl text-orange-700 font-yatra mb-4">
    ए.सी. व नॉन ए.सी. रूम्स
  </h2>
  <p className="text-gray-700">
    यात्रेकरुंसाठी आरामदायक, स्वच्छ आणि किफायतशीर दरात ए.सी. व नॉन ए.सी. रूम्सची सोय उपलब्ध आहे.
  </p>
</div>


    
        {/* Service 2 */}
        <div className="p-6 border rounded-lg shadow-lg hover:shadow-2xl transition bg-white">
          <FaUtensils className="text-5xl text-orange-500 mb-4 mx-auto" />
          <h2 className="text-2xl text-orange-700 font-yatra mb-4">
            घरगुती भोजन
          </h2>
          <p className="text-gray-700">
             शुद्ध, घरगुती पद्धतीने तयार केलेले पारंपरिक महाराष्ट्रीयन सकस व स्वादिष्ट भोजन उपलब्ध आहे.
          </p>
        </div>
    
        {/* Service 3 */}
        <div className="p-6 border rounded-lg shadow-lg hover:shadow-2xl transition bg-white">
          <FaUsers className="text-5xl text-orange-500 mb-4 mx-auto" />
          <h2 className="text-2xl text-orange-700 font-yatra mb-4">
            ४ सदस्यांसाठी एक रूम
          </h2>
          <p className="text-gray-700">
            प्रत्येक रूममध्ये ४ जणांची आरामदायक व्यवस्था.
          </p>
        </div>
    
        {/* Service 4 */}
        <div className="p-6 border rounded-lg shadow-lg hover:shadow-2xl transition bg-white">
          <FaBusAlt className="text-5xl text-orange-500 mb-4 mx-auto" />
          <h2 className="text-2xl text-orange-700 font-yatra mb-4">
            ट्रॅव्हलिंग बस सेवा
          </h2>
          <p className="text-gray-700">
            यात्रा दरम्यान आरामदायक ए.सी. बसद्वारे प्रवासाची सुविधा.
          </p>
        </div>
    
        {/* Service 5 */}
        <div className="p-6 border rounded-lg shadow-lg hover:shadow-2xl transition bg-white">
  <FaTrain className="text-5xl text-orange-500 mb-4 mx-auto" />
  <h2 className="text-2xl text-orange-700 font-yatra mb-4">
    रेल्वे बुकिंग
  </h2>
  <p className="text-gray-700">
    गरजेनुसार रेल्वे प्रवासाची सोय केली जाते. स्लीपर, 3-टियर, 2-टियर, जनरल सीट्स यांसारख्या विविध प्रकारांच्या सीट्स उपलब्ध करून दिल्या जातात.
  </p>
</div>

    
        {/* Service 6 */}
        <div className="p-6 border rounded-lg shadow-lg hover:shadow-2xl transition bg-white">
          <FaClinicMedical className="text-5xl text-orange-500 mb-4 mx-auto" />
          <h2 className="text-2xl text-orange-700 font-yatra mb-4">
            वैद्यकीय सुविधा
          </h2>
          <p className="text-gray-700">
            आवश्यकतेनुसार प्राथमिक वैद्यकीय सेवांची उपलब्धता.
          </p>
        </div>
    
      </div>
    </div>
    
  );
}

export default OurServices;
